export const transformBulkValues = (data, selected) => {
  let newObj = { ...data };
  Object.keys(data).forEach(date => {
    newObj[date] = selected.map((el, i) => {
      const selectedValue = data[date].find(val => val.market_index_id === el.id);
      if (selectedValue) {
        return selectedValue.value;
      } else {
        return '';
      }
    });
  });

  return newObj;
};
